<template>
  <v-bottom-navigation
    :value="value"
    class="primary-color"
    grow
    elevation="7"
    fixed 
  >
    <v-btn to="/">
      <span>Beranda</span>
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-btn to="/lists">
      <span>List Voucher</span>
      <div class="position-relative">
        <span v-if="getPendingReceipts() > 0" class="pending-badge fade-in">{{getPendingReceipts()}}</span>
        <v-icon>mdi-file</v-icon>
      </div>
    </v-btn>
<v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
      >
        <span>Keluar</span>
        <v-icon>mdi-arrow-left-thin-circle-outline</v-icon>
      </v-btn>
      </template>
      <v-card>
        <v-card-title class="text-h5">
          Log Out
        </v-card-title>
        <v-card-text>Anda akan keluar dari aplikasi</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="logout()"
          >
            Logout
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-bottom-navigation>
</template>

<script>
import {mapGetters , mapActions} from 'vuex'
export default {
  name : 'NavigationBar',
    data () {
      return {
        value : 0,
        dialog : false
      }
    },
    computed : {
      ...mapGetters({
        'user' : 'Auth/user',
        'receipts' : 'Forms/receipts'
      })
    },
    methods : {
      ...mapActions({
        logout : 'Auth/signOut'
      }),
      getPendingReceipts () {
        let count = 0
        for (let index = 0; index < this.receipts.length; index++) {
          if(this.receipts[index].status == 0){
            count++
          }  
        }
        return count;
      }
    }
}
</script>

<style scoped>

.pending-badge {
  color : white;
  border-radius: 50%;
  background : salmon;
  display : flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  position: absolute;
  right: -15px;
  top: -10px;
  transform: scale(0.7) ;
}
</style>